module.exports = __webpack_public_path__ + "static/img/ICW.f9fda6a1.svg";